module.exports = __webpack_public_path__ + "static/img/Dr._Tasneem_Akhtar.3588910.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Dr._Tasneem_Akhtar.png
// module id = k1AV
// module chunks = 1